export const Logo = ({ light = false, className = "" }) => (
  <a href="#home" onClick={(e) => e.preventDefault()} className={`flex items-center gap-3 ${className}`} data-testid="logo">
    <svg width="34" height="34" viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="12" fill={light ? "#F8F6F0" : "#1A1917"} />
      <g fill="none" stroke="#C59247" strokeWidth="4" strokeLinecap="round">
        <line x1="14" y1="18" x2="50" y2="18" /><line x1="14" y1="28" x2="50" y2="28" />
        <line x1="14" y1="38" x2="50" y2="38" /><line x1="14" y1="48" x2="36" y2="48" />
      </g>
      <circle cx="46" cy="48" r="4.5" fill="#C59247" />
    </svg>
    <span className={`leading-none ${light ? "text-linen" : "text-ink"}`}>
      <span className="block font-serif text-lg tracking-wide">HAPPY <span className="text-brass">23</span></span>
      <span className="block text-[9px] font-mono uppercase tracking-[0.3em] opacity-70">Blinds & Shutter</span>
    </span>
  </a>
);
